import React, { useState } from "react";
import "../css/faq-item.css";
import { ReactComponent as FaqIcon } from "../assets/icons/faq-add-icon.svg";

const FaqItem = ({ faqQues, faqAns }) => {
  const [ansView, setAnsView] = useState(false);
  return (
    <div className="faq-item">
      <div>
        <h3>{faqQues}</h3>
        <p className={ansView ? "faq-active" : null}>{faqAns}</p>
      </div>
      <button
        onClick={() => {
          setAnsView(!ansView);
        }}
      >
        <FaqIcon className={ansView ? "faq-ic-up" : null} />
      </button>
    </div>
  );
};

export default FaqItem;
